module.exports = __webpack_public_path__ + "img/build-waterproofing-2.63e48b21.jpg";